import gql from 'graphql-tag';

export const EnterpriseLearningPathCurriculumProductsQuery = gql`
  query ProgramCurriculumProductsQuery($ids: [String!]!) {
    ProgramCurriculumProductsV1Resource {
      multiGet(ids: $ids) {
        elements {
          id
          productState {
            ... on ProgramCurriculumProductsV1_programCourseWithStateMember {
              productState: programCourseWithState {
                courseId
                isWishlisted
                enrolledAt
                completedAt
                lastUpdatedAt
                state
                actions
              }
            }
          }
        }
      }
    }
  }
`;

export default EnterpriseLearningPathCurriculumProductsQuery;
